import { forwardRef, useId, type ReactNode, type TextareaHTMLAttributes } from "react";
import { RichTextArea } from "./RichTextArea";

/** Associates only the prose field with its label; formatting buttons sit outside the label. */
export const RichTextField = forwardRef<HTMLTextAreaElement, TextareaHTMLAttributes<HTMLTextAreaElement> & { label: ReactNode; fieldClassName?: string }>(function RichTextField({ label, fieldClassName, id: suppliedId, ...props }, ref) {
  const generated = useId();
  const id = suppliedId ?? `prose-${generated}`;
  return <div className={`rich-text-field ${fieldClassName ?? ""}`.trim()}><label htmlFor={id}>{label}</label><RichTextArea {...props} id={id} ref={ref} /></div>;
});
